import axios from "axios";
import apiUrl from "../../api-url";
import buildFetchDuck from "../../vendor/signal-utils/build-fetch-duck";
import chainReducers from "../../vendor/signal-utils/chain-reducers";
import { Privileges, hasPrivileges } from "../auth/authorization";

// URLS
const ORGANIZATIONS_URL = apiUrl("/iam/organizations");

// Actions
const SET_CURRENT_ORGANIZATION_ID = "Organizations/SET_CURRENT_ORGANIZATION_ID";

const SET_IS_ORGANIZATIONS_LOADED = "Users/SET_IS_ORGANIZATIONS_LOADED";
const SET_IS_ORGANIZATION_MEMBERS_LOADED =
  "Users/SET_IS_ORGANIZATION_MEMBERS_LOADED";

const RECEIVE_ORGANIZATIONS = "Organizations/RECEIVE_ORGANIZATIONS";
const RECEIVE_ORGANIZATION_MEMBERS =
  "Organizations/RECEIVE_ORGANIZATION_MEMBERS";
const RECEIVE_ORGANIZATION_TYPES = "Organizations/RECEIVE_ORGANIZATION_TYPES";

const ADD_ORGANIZATION = "Organizations/ADD_ORGANIZATION";
const ADD_ORGANIZATION_SUCCEEDED = "Organizations/ADD_ORGANIZATION_SUCCEEDED";
const ADD_ORGANIZATION_FAILED = "Organizations/ADD_ORGANIZATION_FAILED";

const UPDATE_ORGANIZATION = "Organizations/UPDATE_ORGANIZATION";
const UPDATE_ORGANIZATION_SUCCEEDED =
  "Organizations/UPDATE_ORGANIZATION_SUCCEEDED";
const UPDATE_ORGANIZATION_FAILED = "Organizations/UPDATE_ORGANIZATION_FAILED";

const DELETE_ORGANIZATION = "Organizations/DELETE_ORGANIZATION";
const DELETE_ORGANIZATION_SUCCEEDED =
  "Organizations/DELETE_ORGANIZATION_SUCCEEDED";
const DELETE_ORGANIZATION_FAILED = "Organizations/DELETE_ORGANIZATION_FAILED";

const duck = buildFetchDuck("organizations");

export function fetchOrganizations() {
  const url = `${ORGANIZATIONS_URL}`;

  /*return dispatch => {
    dispatch(setIsOrganizationsLoaded(false));
    return dispatch(duck.fetch(url));
  };*/

  return dispatch => {
    dispatch(setIsOrganizationsLoaded(false));
    return Promise.all([axios.get(`${url}`)])
      .then(responses => {
        dispatch({
          type: RECEIVE_ORGANIZATIONS,
          payload: responses[0].data
        });
        dispatch(setIsOrganizationsLoaded(true));
      })
      .catch(err => {
        dispatch({
          type: RECEIVE_ORGANIZATIONS,
          payload: []
        });
        dispatch(setIsOrganizationsLoaded(true));
      });
  };
}

export function fetchOrganizationMembers(organizationId) {
  const url = `${ORGANIZATIONS_URL}/${organizationId}/members`;

  return dispatch => {
    dispatch(setIsOrganizationMembersLoaded(false));
    return Promise.all([axios.get(`${url}`)])
      .then(responses => {
        dispatch({
          type: RECEIVE_ORGANIZATION_MEMBERS,
          payload: responses[0].data
        });
        dispatch(setIsOrganizationMembersLoaded(true));
      })
      .catch(err => {
        dispatch({
          type: RECEIVE_ORGANIZATION_MEMBERS,
          payload: []
        });
        dispatch(setIsOrganizationMembersLoaded(true));
      });
  };
}

export function fetchOrganizationTypes() {
  const url = `${ORGANIZATIONS_URL}/orgtypes`;

  return dispatch => {
    return Promise.all([axios.get(`${url}`)])
      .then(responses => {
        dispatch({
          type: RECEIVE_ORGANIZATION_TYPES,
          payload: responses[0].data
        });
      })
      .catch(err => {
        dispatch({
          type: RECEIVE_ORGANIZATION_TYPES,
          payload: []
        });
        console.log(err);
      });
  };
}

export function setCurrentOrganization(organizationId) {
  sessionStorage.setItem("currentOrganization", organizationId);

  return dispatch => {
    // fetch org members if user has manage roles permission,
    // easier to check this in one central location.
    // If security issue will have to moved to all areas where set current org is called
    if (hasPrivileges([Privileges.MANAGE_USERS])) {
      dispatch(fetchOrganizationMembers(organizationId));
    }

    dispatch({
      type: SET_CURRENT_ORGANIZATION_ID,
      currentOrganizationId: organizationId
    });
  };
}

export function setIsOrganizationsLoaded(isLoaded) {
  return dispatch => {
    return dispatch({
      type: SET_IS_ORGANIZATIONS_LOADED,
      isOrganizationsLoaded: isLoaded
    });
  };
}

export function setIsOrganizationMembersLoaded(isLoaded) {
  return dispatch => {
    return dispatch({
      type: SET_IS_ORGANIZATION_MEMBERS_LOADED,
      isOrganizationMembersLoaded: isLoaded
    });
  };
}

export function addOrganization(payload) {
  return function(dispatch) {
    dispatch({
      type: ADD_ORGANIZATION,
      payload
    });
    dispatch(setIsOrganizationsLoaded(false));
    const url = ORGANIZATIONS_URL;
    return axios
      .post(url, payload)
      .then(resp => {
        dispatch({
          type: ADD_ORGANIZATION_SUCCEEDED
        });
        dispatch(fetchOrganizations());
      })
      .catch(error => {
        dispatch({
          type: ADD_ORGANIZATION_FAILED,
          error
        });
        dispatch(setIsOrganizationsLoaded(true));
      });
  };
}

export function updateOrganization(organizationId, payload) {
  return function(dispatch) {
    dispatch({
      type: UPDATE_ORGANIZATION,
      organizationId,
      payload
    });
    dispatch(setIsOrganizationsLoaded(false));
    const url = ORGANIZATIONS_URL + `/${organizationId}`;
    return axios
      .patch(url, payload)
      .then(resp => {
        dispatch({
          type: UPDATE_ORGANIZATION_SUCCEEDED,
          organizationId,
          payload
        });
        dispatch(fetchOrganizations());
      })
      .catch(error => {
        dispatch({
          type: UPDATE_ORGANIZATION_FAILED,
          organizationId,
          error
        });
        dispatch(setIsOrganizationsLoaded(true));
      });
  };
}

export function deleteOrganization(organizationId) {
  return function(dispatch) {
    dispatch({
      type: DELETE_ORGANIZATION,
      organizationId
    });
    dispatch(setIsOrganizationsLoaded(false));
    const url = ORGANIZATIONS_URL + `/${organizationId}`;
    return axios
      .delete(url)
      .then(resp => {
        dispatch({
          type: DELETE_ORGANIZATION_SUCCEEDED
        });
        dispatch(fetchOrganizations());
      })
      .catch(error => {
        dispatch({
          type: DELETE_ORGANIZATION_FAILED,
          organizationId,
          error
        });
        dispatch(setIsOrganizationsLoaded(true));
      });
  };
}

export const getCurrentOrganizationId = state =>
  state.organizations.currentOrganizationId;

const initialState = {
  data: [],
  organizationMembers: [],
  isOrganizationMembersLoaded: true,
  isOrganizationsLoaded: true
};

function OrganizationsReducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_CURRENT_ORGANIZATION_ID:
      return {
        ...state,
        currentOrganizationId: action.currentOrganizationId
      };
    case SET_IS_ORGANIZATIONS_LOADED:
      return {
        ...state,
        isOrganizationsLoaded: action.isOrganizationsLoaded
      };
    case SET_IS_ORGANIZATION_MEMBERS_LOADED:
      return {
        ...state,
        isOrganizationMembersLoaded: action.isOrganizationMembersLoaded
      };
    case RECEIVE_ORGANIZATIONS:
      return {
        ...state,
        data: action.payload,
        isOrganizationsLoaded: true
      };
    case RECEIVE_ORGANIZATION_MEMBERS:
      return {
        ...state,
        organizationMembers: action.payload,
        isOrganizationMembersLoaded: true
      };
    case RECEIVE_ORGANIZATION_TYPES:
      return {
        ...state,
        organizationTypes: action.payload
      };
    default:
      return state;
  }
}

export default chainReducers([OrganizationsReducer, duck.reducer]);



// WEBPACK FOOTER //
// ./src/modules/organizations/OrganizationsState.js